export enum ForgotConfig {
	duration = 30,
}

export { default as ForgotPassword } from './Password';
export * from './Password';

export { default as ForgotEmail } from './Email';
export * from './Email';
